module.exports = __webpack_public_path__ + "static/media/award.2524395e.svg";